module.exports = __webpack_public_path__ + "static/img/loading_jinridui.cad78c47.gif";